import { ArticleDate } from '@/components/ArticleDate';
import { Controls, Row, Select, Toggle } from 'base/components/preview';
import { useEffect, useState } from 'react';

const formats = ['D MMMM, YYYY', 'DD MMMM YYYY, H:m:s', 'DD MMMM YYYY H:m:s', 'DD.MM.YYYY HH:mm:ss'];

export const ArticleDatePreview = () => {
  const [date, setDate] = useState('');
  const [dateFormat, setDateFormat] = useState(formats[0]);
  const [showUpdatedDate, setShowUpdatedDate] = useState(true);

  useEffect(() => {
    setDate(new Date().toISOString());
  }, []);

  const controls = (
    <Controls>
      <Select label="Date format" items={formats} onChange={setDateFormat} />
      <Toggle label="Show updated date" onChange={setShowUpdatedDate} defaultChecked />
    </Controls>
  );

  return (
    <Row
      headline="Article Date"
      caption={controls}
      content={
        <ArticleDate
          publishedDatetime={date}
          updatedDatetime={showUpdatedDate ? date : undefined}
          format={dateFormat}
        />
      }
    />
  );
};

export default ArticleDatePreview;
